module.exports = __webpack_public_path__ + "static/media/soc-fb-white.50ec3165.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soc/soc-fb-white.svg
// module id = 933
// module chunks = 270